import React, { useState, useEffect } from 'react';
import { API_URL } from "../../shared/constant";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-date-picker";
import Loader from "../../shared/loader";

const Dashboard = () => {
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [pendingSales, setPendingSales] = useState([]);
    const [showPendingSummary, setShowPendingSummary] = useState(false);
    const [salesSummary, setSalesSummary] = useState([]);
    const [showSalesSummary, setShowSalesSummary] = useState(false);
    const [purchaseSummary, setPurchaseSummary] = useState([]);
    const [showPurchaseSummary, setShowPurchaseSummary] = useState(false);
    const [salesReturnSummary, setSalesReturnSummary] = useState([]);
    const [showSalesReturnSummary, setShowSalesReturnSummary] = useState(false);
    const [salesInProgress, setSalesInProgress] = useState({
        total_items: 0,
        total_amount: 0,
        total_qty: 0,
    });
    const [salesCompleted, setSalesCompleted] = useState({
        total_items: 0,
        total_amount: 0,
        total_qty: 0,
    });
    const [purchaseOrder, setPurchaseOrder] = useState({
        total_items: 0,
        total_amount: 0,
        total_qty: 0,
    });
    const [salesReturn, setSalesReturn] = useState({
        total_items: 0,
        total_amount: 0,
        total_qty: 0,
    });

    const fetchDashboardData = () => {
        setLoading(true);
        const fromDateStr = moment(fromDate).format("YYYY-MM-DD");
        const toDateStr = moment(toDate).format("YYYY-MM-DD");

        axios.post(API_URL.DASHBOARD_DATA, {
            from_date: fromDateStr,
            to_date: toDateStr
        }).then((response) => {
            if (response.data.status === 1) {
                // Handle pendingSales
                if (response.data.data.pendingSales) {
                    setSalesInProgress({
                        total_items: response.data.data.pendingSales.total_items || 0,
                        total_amount: response.data.data.pendingSales.total_amount || 0,
                        total_qty: response.data.data.pendingSales.total_qty || 0,
                    });
                } else {
                    setSalesInProgress({ total_items: 0, total_amount: 0, total_qty: 0 });
                }

                // Handle completedSales
                if (response.data.data.completedSales) {
                    setSalesCompleted({
                        total_items: response.data.data.completedSales.total_items || 0,
                        total_amount: response.data.data.completedSales.total_amount || 0,
                        total_qty: response.data.data.completedSales.total_qty || 0,
                    });
                } else {
                    setSalesCompleted({ total_items: 0, total_amount: 0, total_qty: 0 });
                }

                // Handle purchase
                if (response.data.data.purchase) {
                    setPurchaseOrder({
                        total_items: response.data.data.purchase.total_items || 0,
                        total_amount: response.data.data.purchase.total_amount || 0,
                        total_qty: response.data.data.purchase.total_qty || 0,
                    });
                } else {
                    setPurchaseOrder({ total_items: 0, total_amount: 0, total_qty: 0 });
                }

                // Handle salesReturn
                if (response.data.data.salesReturn) {
                    setSalesReturn({
                        total_items: response.data.data.salesReturn.total_items || 0,
                        total_amount: response.data.data.salesReturn.total_amount || 0,
                        total_qty: response.data.data.salesReturn.total_qty || 0,
                    });
                } else {
                    setSalesReturn({ total_items: 0, total_amount: 0, total_qty: 0 });
                }
            }
            setLoading(false);
        }).catch((error) => {
            console.error("Error fetching dashboard data:", error);
            setLoading(false);
        })
    };

    const getPendingSales = () => {
        const fromDateStr = moment(fromDate).format("YYYY-MM-DD");
        const toDateStr = moment(toDate).format("YYYY-MM-DD");
        
        axios.post(API_URL.PENDING_SUMMARY, {
            from_date: fromDateStr,
            to_date: toDateStr
        }).then((response) => {
            if (response.data.status === 1) {
                setPendingSales(response.data.data || []);
            } else {
                setPendingSales([]);
            }
        }).catch((error) => {
            console.error("Error fetching pending sales:", error);
            setPendingSales([]);
        });
    };

    const getSalesSummary = () => {
        const fromDateStr = moment(fromDate).format("YYYY-MM-DD");
        const toDateStr = moment(toDate).format("YYYY-MM-DD");
        
        axios.post(API_URL.SALES_SUMMARY, {
            from_date: fromDateStr,
            to_date: toDateStr
        }).then((response) => {
            if (response.data.status === 1) {
                setSalesSummary(response.data.data || []);
            } else {
                setSalesSummary([]);
            }
        }).catch((error) => {
            console.error("Error fetching sales summary:", error);
            setSalesSummary([]);
        });
    };

    const getPurchaseSummary = () => {
        const fromDateStr = moment(fromDate).format("YYYY-MM-DD");
        const toDateStr = moment(toDate).format("YYYY-MM-DD");
        
        axios.post(API_URL.PURCHASE_SUMMARY, {
            from_date: fromDateStr,
            to_date: toDateStr
        }).then((response) => {
            if (response.data.status === 1) {
                setPurchaseSummary(response.data.data || []);
            } else {
                setPurchaseSummary([]);
            }
        }).catch((error) => {
            console.error("Error fetching purchase summary:", error);
            setPurchaseSummary([]);
        });
    };

    const getSalesReturnSummary = () => {
        const fromDateStr = moment(fromDate).format("YYYY-MM-DD");
        const toDateStr = moment(toDate).format("YYYY-MM-DD");
        
        axios.post(API_URL.SALES_RETURN_SUMMARY, {
            from_date: fromDateStr,
            to_date: toDateStr
        }).then((response) => {
            if (response.data.status === 1) {
                setSalesReturnSummary(response.data.data || []);
            } else {
                setSalesReturnSummary([]);
            }
        }).catch((error) => {
            console.error("Error fetching sales return summary:", error);
            setSalesReturnSummary([]);
        });
    };

    const handleSalesInProgressClick = () => {
        if (!showPendingSummary) {
            getPendingSales();
        }
        setShowPendingSummary(!showPendingSummary);
    };

    const handleSalesCompletedClick = () => {
        if (!showSalesSummary) {
            getSalesSummary();
        }
        setShowSalesSummary(!showSalesSummary);
    };

    const handlePurchaseOrderClick = () => {
        if (!showPurchaseSummary) {
            getPurchaseSummary();
        }
        setShowPurchaseSummary(!showPurchaseSummary);
    };

    const handleSalesReturnClick = () => {
        if (!showSalesReturnSummary) {
            getSalesReturnSummary();
        }
        setShowSalesReturnSummary(!showSalesReturnSummary);
    };
    
    useEffect(() => {
        fetchDashboardData();
    }, [fromDate, toDate]);

    const handleDateChange = (dateType, date) => {
        if (dateType === 'from') {
            setFromDate(date);
        } else {
            setToDate(date);
        }
    };

    return (
        <>
            <div className="row">
                {/* <div className="col-12">
                    <h1>Dashboard</h1>
                    <div className="separator mb-5"></div>
                </div> */}
                
                {/* Date Filter Section */}
                <div className="col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>From Date</label>
                                        <DatePicker
                                            format="dd/MM/y"
                                            className="form-control"
                                            onChange={(date) => handleDateChange('from', date)}
                                            value={fromDate}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DatePicker
                                            format="dd/MM/y"
                                            className="form-control"
                                            onChange={(date) => handleDateChange('to', date)}
                                            value={toDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Dashboard Cards */}
                {loading && <div className="col-lg-12 col-md-12 text-center"><Loader></Loader></div>}
                {!loading && (
                    <>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card" style={{ 
                                borderLeft: '4px solid #ffc107',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                border: showPendingSummary ? '2px solid #ffc107' : 'none'
                            }}
                            onClick={handleSalesInProgressClick}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(255, 193, 7, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 15px rgba(0, 0, 0, 0.1), 0 1px 8px rgba(0, 0, 0, 0.1)';
                            }}>
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="text-muted mb-2" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                                                Sales In Progress Order
                                            </h6>
                                            <h2 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#ffc107' }}>
                                                {salesInProgress.total_items}
                                            </h2>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Amount</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>₹{salesInProgress.total_amount.toLocaleString('en-IN')}</span>
                                                </div>
                                                <div className="text-right">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Quantity</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>{salesInProgress.total_qty}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-3">
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 193, 7, 0.2) 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="iconsminds-clock" style={{ fontSize: '2rem', color: '#ffc107' }}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card" style={{ 
                                borderLeft: '4px solid #28a745',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                border: showSalesSummary ? '2px solid #28a745' : 'none'
                            }}
                            onClick={handleSalesCompletedClick}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(40, 167, 69, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 15px rgba(0, 0, 0, 0.1), 0 1px 8px rgba(0, 0, 0, 0.1)';
                            }}>
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="text-muted mb-2" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                                                Sales Completed Order
                                            </h6>
                                            <h2 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#28a745' }}>
                                                {salesCompleted.total_items}
                                            </h2>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Amount</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>₹{salesCompleted.total_amount.toLocaleString('en-IN')}</span>
                                                </div>
                                                <div className="text-right">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Quantity</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>{salesCompleted.total_qty}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-3">
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(40, 167, 69, 0.2) 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="iconsminds-check" style={{ fontSize: '2rem', color: '#28a745' }}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card" style={{ 
                                borderLeft: '4px solid #dc3545',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                border: showSalesReturnSummary ? '2px solid #dc3545' : 'none'
                            }}
                            onClick={handleSalesReturnClick}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(220, 53, 69, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 15px rgba(0, 0, 0, 0.1), 0 1px 8px rgba(0, 0, 0, 0.1)';
                            }}>
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="text-muted mb-2" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                                                Sales Return Order
                                            </h6>
                                            <h2 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#dc3545' }}>
                                                {salesReturn.total_items}
                                            </h2>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Amount</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>₹{salesReturn.total_amount.toLocaleString('en-IN')}</span>
                                                </div>
                                                <div className="text-right">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Quantity</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>{salesReturn.total_qty}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-3">
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(220, 53, 69, 0.2) 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="iconsminds-arrow-left" style={{ fontSize: '2rem', color: '#dc3545' }}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card" style={{ 
                                borderLeft: '4px solid #007bff',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                border: showPurchaseSummary ? '2px solid #007bff' : 'none'
                            }}
                            onClick={handlePurchaseOrderClick}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 123, 255, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 1px 15px rgba(0, 0, 0, 0.1), 0 1px 8px rgba(0, 0, 0, 0.1)';
                            }}>
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="flex-grow-1">
                                            <h6 className="text-muted mb-2" style={{ fontSize: '0.875rem', fontWeight: '500' }}>
                                                Purchase Order
                                            </h6>
                                            <h2 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                                                {purchaseOrder.total_items}
                                            </h2>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Amount</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>₹{purchaseOrder.total_amount.toLocaleString('en-IN')}</span>
                                                </div>
                                                <div className="text-right">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>Quantity</small>
                                                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>{purchaseOrder.total_qty}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-3">
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '12px',
                                                background: 'linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 123, 255, 0.2) 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="iconsminds-shopping-cart" style={{ fontSize: '2rem', color: '#007bff' }}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <div className="row">
            {showPendingSummary && (
                <div className="col-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="mb-0">Pending Sales Summary</h5>
                                <button 
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => setShowPendingSummary(false)}
                                >
                                    <i className="fa fa-times me-1"></i> Close
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Total Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pendingSales && pendingSales.length > 0 ? (
                                            pendingSales.map((group, groupIndex) => (
                                                <tr key={groupIndex}>
                                                    <td style={{ fontWeight: '600' }}>{group.category_name} - {group.subcategory_name} - {group.size_name}</td>
                                                    <td>{group.total_qty}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center text-muted py-4">
                                                    No pending sales data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSalesSummary && (
                <div className="col-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="mb-0">Sales Completed Summary</h5>
                                <button 
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => setShowSalesSummary(false)}
                                >
                                    <i className="fa fa-times me-1"></i> Close
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Total Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesSummary && salesSummary.length > 0 ? (
                                            salesSummary.map((group, groupIndex) => (
                                                <tr key={groupIndex}>
                                                    <td style={{ fontWeight: '600' }}>{group.category_name} - {group.subcategory_name} - {group.size_name}</td>
                                                    <td>{group.total_qty}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center text-muted py-4">
                                                    No sales data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showPurchaseSummary && (
                <div className="col-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="mb-0">Purchase Order Summary</h5>
                                <button 
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => setShowPurchaseSummary(false)}
                                >
                                    <i className="fa fa-times me-1"></i> Close
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Total Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseSummary && purchaseSummary.length > 0 ? (
                                            purchaseSummary.map((group, groupIndex) => (
                                                <tr key={groupIndex}>
                                                    <td style={{ fontWeight: '600' }}>{group.category_name} - {group.subcategory_name} - {group.size_name}</td>
                                                    <td>{group.total_qty}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center text-muted py-4">
                                                    No purchase data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSalesReturnSummary && (
                <div className="col-6 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="mb-0">Sales Return Summary</h5>
                                <button 
                                    className="btn btn-sm btn-secondary"
                                    onClick={() => setShowSalesReturnSummary(false)}
                                >
                                    <i className="fa fa-times me-1"></i> Close
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Total Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salesReturnSummary && salesReturnSummary.length > 0 ? (
                                            salesReturnSummary.map((group, groupIndex) => (
                                                <tr key={groupIndex}>
                                                    <td style={{ fontWeight: '600' }}>{group.category_name} - {group.subcategory_name} - {group.size_name}</td>
                                                    <td>{group.total_qty}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center text-muted py-4">
                                                    No sales return data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </>
    )
}

export default Dashboard;